module.exports = __webpack_public_path__ + "img/3.c188c91a.jpg";